import * as SwitchPrimitive from '@radix-ui/react-switch';

import { Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

export const Switch = (props: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  id?: string;
  className?: string;
  labelClassName?: string;
  size?: 'sm' | 'md';
  labelPosition?: 'left' | 'right';
}) => {
  const labelPosition = props.labelPosition ?? 'right';
  return (
    <div className={cn('flex items-center gap-2', props.className)}>
      {labelPosition === 'left' && (
        <label
          htmlFor={props.id}
          className={cn(
            props.size === 'sm' ? 'text-sm' : 'text-base',
            props.labelClassName
          )}
        >
          {props.label}
        </label>
      )}

      <SwitchPrimitive.Root
        className={cn(
          'inline-flex items-center rounded-full bg-quaternary transition data-[state=checked]:bg-brand-primary',
          props.size === 'sm' ? 'h-4 w-8' : 'h-5 w-10'
        )}
        id={props.id}
        checked={props.checked}
        onCheckedChange={props.onChange}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            ' rounded-full bg-white transition ',
            props.size === 'sm'
              ? 'size-3 translate-x-1 data-[state=checked]:translate-x-4'
              : 'size-4 translate-x-1 data-[state=checked]:translate-x-5'
          )}
        />
      </SwitchPrimitive.Root>
      {labelPosition === 'right' && (
        <Text
          variant={props.size === 'sm' ? 'sm' : 'md'}
          className={cn(props.labelClassName)}
        >
          {props.label}
        </Text>
      )}
    </div>
  );
};
